import firebase from 'firebase/app'

import * as algolia from './algolia'

import { uuid } from '../helpers'
import { VALIDATION_STATUS } from '../constant'


/**
 * Get all info about an user
 * @param {String} id - The id of the user
 * @returns {User} The user object
 */
const editCasting = async (castingId, props) => {
  const db = firebase.firestore()
  await db
    .collection('castings')
    .doc(castingId)
    .update(props)
}


export const editCastingProfile = async (castingId, profileId, data) => {
  const db = firebase.firestore()
  await db.collection('castings').doc(castingId).collection('profiles').doc(profileId)
    .update(data)

  const snapshot = await db.collection('castings').doc(castingId).collection('profiles').doc(profileId)
    .get()

  return {
    id: snapshot.id,
    ...snapshot.data(),
  }
}


export const addManualProfile = async (castingId, profileData) => {
  const db = firebase.firestore()
  const storage = firebase.storage()
  const batch = db.batch()
  const doc = db.collection('castings').doc(castingId).collection('profiles').doc()

  const {
    folio = [],
    ...profile
  } = profileData

  profile.id = doc.id
  profile.is_manual = true
  profile.created_at = new Date()
  profile.validation_status = VALIDATION_STATUS.PENDING
  batch.set(doc, { ...profile })

  const folioPaths = await Promise.all(folio.map(async (file) => {
    const filename = `${uuid()}.${file.name.split('.').pop()}`
    const task = await storage.ref().child('users').child('images').child('others')
      .child(filename)
      .put(file, { contentType: file.type })

    return task.ref.getDownloadURL()
  }))

  profile.folio = []
  folioPaths.forEach((path) => {
    const folioDoc = doc.collection('folio').doc()
    const item = {
      width: 1,
      height: 1,
      original: path,
      id: folioDoc.id,
      created_at: new Date(),
    }

    batch.set(folioDoc, item)
    profile.folio.push(item)
  })

  await batch.commit()

  return profile
}


export const editCastingProfiles = async (castingId, profilesToAdd, profilesToRemove) => {
  const promises = []
  const profiles = []
  const db = firebase.firestore()
  const doc = db.collection('castings').doc(castingId)
  const batch = db.batch()

  profilesToRemove.forEach(profileId => promises.push(async () => {
    const profile = await algolia.getById(algolia.user, profileId)

    if (profile && Array.isArray(profile.folios)) {

      profile.folios.forEach(folio => batch.delete(doc.collection('profiles').doc(profileId).collection('folio').doc(folio.id)))
    }

    batch.delete(doc.collection('profiles').doc(profileId))
  }))

  profilesToAdd.forEach(profileId => promises.push(async () => {
    const profile = await algolia.getUserById(profileId)
    const folios = profile.folios || []

    const data = {
      id: profileId,
      user_id: profileId,
      email: profile.email,
      created_at: new Date(),
      lastname: profile.lastname,
      firstname: profile.firstname,
      validation_status: VALIDATION_STATUS.PENDING,
    }

    const profileDoc = doc.collection('profiles').doc(profileId)

    batch.set(profileDoc, data)

    folios.filter(f => !f.hidden && !f.is_hidden && !f.deleted && !f.is_deleted && f.picture).forEach((folio) => {
      const data = { ...folio }

      data.id = folio.objectID

      delete data.objectID
      delete data._highlightResult
      batch.set(profileDoc.collection('folio').doc(folio.objectID), folio)
    })

    profiles.push({
      ...profile,
      ...data,
    })
  }))

  await Promise.all(promises.map(x => x()))
  await batch.commit()
  return profiles
}


export default editCasting
